<div class="container container_type_main">
  <app-mobile-apps-banner></app-mobile-apps-banner>
</div>
